'use strict';
var optimizeCall = require('./optimizeCall');

var optimizedResizeCall = optimizeCall();
window.addEventListener('resize', optimizedResizeCall.call);

exports.getDocumentSize = function () {
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  };
};

exports.getScreenAvailSize = function () {
  return {
    width: window.screen.availWidth || window.screen.width,
    height: window.screen.availWidth || window.screen.height
  };
};

exports.onDocumentResize = function (cb) {
  optimizedResizeCall.add(cb);
};

exports.offDocumentResize = function (cb) {
  optimizedResizeCall.remove(cb);
};



// WEBPACK FOOTER //
// ./src/helper/domHelper.js